import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditRedeemBrandCoupon from "../../../components/SuperAdmin/RedeemBrandCoupon/EditRedeemBrandCoupon";

export default withRouter(connect()(EditRedeemBrandCoupon));
